import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface DrawerContextProps {
  isDrawerOpen: boolean;
  updateDrawer: (open: boolean) => void;
}

const DrawerContext = createContext<DrawerContextProps | null>(null);

export const DrawerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(
    localStorage.getItem("isDrawerOpen") === "true"
  );

  const updateDrawer = (open: boolean) => {
    setIsDrawerOpen(open);
    // localStorage.setItem("isDrawerOpen", String(open));
    // window.dispatchEvent(new Event("drawer-change"));
  };

  //   useEffect(() => {
  //     const handler = () => {
  //       setIsDrawerOpen(localStorage.getItem("isDrawerOpen") === "true");
  //     };

  //     window.addEventListener("drawer-change", handler);
  //     return () => window.removeEventListener("drawer-change", handler);
  //   }, []);

  return (
    <DrawerContext.Provider value={{ isDrawerOpen, updateDrawer }}>
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawer = () => {
  const ctx = useContext(DrawerContext);
  if (!ctx) throw new Error("useDrawer must be used inside DrawerProvider");
  return ctx;
};
